<template>
  <La3 :ratio="'426px 1fr 603px'" :styleLeft="{
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: '20px 20px 20px 23px',
    gap: '14px'
  }"  :styleCenter="{
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: '14px 32px 55px 32px',
    gap: '14px',
    position: 'relative'
  }"  :styleRight="{
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: '27px 15px 5px 32px',
    gap: '16px',
    position: 'relative'
  }">
    <template slot="left">
      <div :style="{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%'
      }">
        <Select :defaultValue="store" @input="store=$event" :width="'100%'">
          <option :value="null">全部區域</option>
          <option v-for="t in restaurants" :key="`rest-${t}`" :value="t">{{t}}</option>
        </Select>
      </div>
      <div :style="{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%'
      }">
        <Select :defaultValue="type" @input="type=$event" :width="'170px'">
          <option :value="null">所有商品</option>
          <option v-for="t in typesp" :key="t" :value="t">{{t}}</option>
        </Select>
        <Select :defaultValue="usage" @input="usage=$event" :width="'192px'">
          <option :value="null">商品用途</option>
            <option v-for="t in usages" :key="t" :value="t">{{t}}</option>
        </Select>
      </div>
      <div :style="{width: '100%'}"><SearchInput  :defaultValue="searchText" @input="searchText=$event" :width="'100%'"/></div>
      <div :style="{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '10px',
        overflowY: 'auto',
        padding: '5px'

      }">
        <div draggable @dragstart="startDrag($event, prod._id)" v-for="(prod, p) in prods" :key="`prod-${p}`" class="prod">
          <div :style="{textAlign: 'start'}">{{prod.name}}</div>
          <div>${{prod.price}}</div>
        </div>
      </div>
    </template>

    <template slot="center">
      <div :style="{width: '100%'}"><RBtn :style="{marginLeft: 'auto'}" :icon="'add'" :text="'新增加價換購'" @click="multi.push([])" :bg="'var(--color-checked)'"/></div>
      <div :style="{width: '100%', overflowY: 'auto', paddingBottom: '20px', display: 'flex', flexDirection: 'column', gap: '20px', paddingRight: '5px'}">
        <div class="len1" v-if="false">
          <div>
            <div>固定內容</div>
            <div>將所需餐點拖曳到方框內</div>
          </div>
          <Draggable tag="div" class="items-body" v-model="single">
            <div v-for="(itm, i) in single" :key="`single-${i}`"  class="single">
              <div>{{itm[0].item.name}}</div>
              <DelBtn :style="{marginLeft: 'auto'}" @click="single.splice(i, 1)"/>
            </div>
          </Draggable>
          <div class="drop"
          @drop="onDrop($event, 'single', 0);changeBG(false, 0)"  :ref="'drop-0'"
          @dragenter="changeBG(true, 0)"
          @dragleave="changeBG(false, 0)"
          @dragover.prevent
          @dragenter.prevent></div>
        </div>
        <div v-for="(itm, i) in multi" :key="`single-${i}`"  class="len2">
          <div :style="{display: 'flex', alignItems:'center', justifyContent:'space-between'}">
            <div>{{i+1}}.選擇(可加價換購) <button :disabled="i===0" @click="goup(i)">⬆️</button><button @click="godown(i)" :disabled="i===multi.length-1">⬇️</button> </div>
            <RBtn title="複製" @click="multi.push(JSON.parse(JSON.stringify(itm)))" class="clone" :style="{width: '40px', height: '40px', padding:'5px'}" :icon="'clone'" :bg="'transparent'"/>
          </div>
          <Draggable tag="div" class="items-body" v-model="multi[i]">
            <div v-for="(itmItem, j) in itm" :key="`mulit-${i}-${j}`" class="mulit">
              <div>{{itmItem.item.name}}</div>
              <div v-if="j===0" class="default" :style="{marginLeft: 'auto'}">預設</div>
              <template v-else>
                <div class="priceDiff" :style="{marginLeft: 'auto'}">可加價 <input type="text" v-model="itmItem.priceDiff"> 元，換購</div>
                <switchboxsVue :title="'可選'" :defaultValue="itmItem.selectable" @update="itmItem.selectable=$event "/>
              </template>
              <DelBtn  @click="multi[i].splice(j, 1)"/>
            </div>
          </Draggable>
          <div  class="drop"
          @drop="onDrop($event, 'multi', i);changeBG(false, i+1)" :ref="`drop-${i+1}`"
          @dragenter="changeBG(true, i+1)"
          @dragleave="changeBG(false, i+1)"
          @dragover.prevent
          @dragenter.prevent></div>
        </div>
        <div class="len2 groups" tip="選項群組">
          <div>
            <div>選項群組</div>
            <RBtn title="複製" @click="selectGroup=true" class="addCoupon" :style="{width: '40px', height: '40px', padding:'5px', marginLeft: 'auto'}" :icon="'add'" :bg="'transparent'"/>
          </div>
          <div class="items-body" :style="{paddingBlock: '14px'}">
            <div v-for="(itm, i) in groups" :key="`single-${i}`"  class="single">
              <div :style="{width: 'fill'}">{{itm.name}}</div>
              <DelBtn @click="groups.splice(i, 1)"/>
            </div>
          </div>
        </div>
        <div class="len2 coupon" tip="優惠券">
          <div>
            <div>優惠券</div>
            <RBtn title="複製" @click="selectone=true" class="addCoupon" :style="{width: '40px', height: '40px', padding:'5px', marginLeft: 'auto'}" :icon="'add'" :bg="'transparent'"/>
          </div>
          <div class="items-body" :style="{paddingBlock: '14px'}">
            <div v-for="(itm, i) in coupons" :key="`single-${i}`"  class="single">
              <div >{{itm.item.couponName}}</div>
              <Num :style="{marginLeft: 'auto', marginRight: '20px'}" :defaultValue="itm.count" @input="itm.count=$event "/>
              <DelBtn @click="coupons.splice(i, 1)"/>
            </div>
          </div>
        </div>
      </div>
      <div id="priceCalculate">
        <div label="原價"><div><div>{{pricedefault}}</div></div></div>
        <div label="優惠"><div><input type="text" v-model="discount" disabled></div></div>
        <div label="售價" ref="price"><div :style="{color: '#FF7373'}"><input type="text" :style="{color: '#FF7373'}" v-model="finalprice" disabled></div></div>
      </div>
    </template>

    <div class="setfields" id="settingsets" v-if="item">
        <div class="setTitle">組合</div>
        <div class="df">
          <div class="field top" label="商品編號" :style="{lineHeight: '.8em', fontWeight: 700, fontSize: '22px', minWidth: '300px', color: 'var(--color-pri)', letterSpacing:'.1em'}">{{item.id}}</div>
          <div class="field top" label="*單位" ref="unit" :style="{lineHeight: '.8em', fontWeight: 500, fontSize: '22px', minWidth: '300px', color: 'var(--color-pri)', letterSpacing:'.1em'}">{{item.unit}}</div>
        </div>
        <div class="df">
          <div class="field" label="*商品類別" ref="type">
            <Select :style="{width: '205px'}" :defaultValue="item.type" @input="item.type=$event">
              <option v-for="t in types" :key="t" :value="t">{{t}}</option>
            </Select>
          </div>
          <div class="field" label="*多人組合"><input type="checkbox" v-model="item.group" id="group"></div>
        </div>
        <div class="df" :style="{gap: '15px'}">
          <div class="field" label="組合人數"><input type="text" v-model.number="item.groupNum" class="center" :style="{width: '67px', textAlign:'center'}"/></div>
          <div class="field" label="組合單位"><input type="text" v-model="item.groupUnit" class="center" :style="{width: '67px', textAlign:'center'}"></div>
          <div class="field" label="數量修改"><input type="checkbox" v-model="item.isFloat" id="group"></div>
        </div>
        <div class="field c" label="*商品名稱" ref="name"><textarea v-model="item.name" :style="{height: '3em'}"/></div>
        <div class="field c" label="商品名稱2" ref="name2"><textarea v-model="item.name2" :style="{height: '3em'}"/></div>
        <div class="field c" label="商品介紹"><textarea v-model="item.description"></textarea></div>
        <div class="field c" label="*販售區域點" ref="area"><CheckboxVue :style="{flexDirection: 'row', flexWrap: 'wrap'}"
          :options="restaurants" :defaultValue="item.area" @input="item.area=$event"/></div>
        <label for="img" id="uploadimage" v-if="!image || !image.filename">
          <div class="uploadimage">
          <input type="file" id="img" accept="image/png, image/jpeg" @change="uploadFile($event, 'rest')" hidden>
          </div>
        </label>
        <div v-else @click="image=null" :style="{display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', paddingLeft: '15px'}">
          <img class="imageBox" :src="`${VUE_APP_BASE_URL}${image.filename}`">
        </div>
        <Btns @save="saveSet" @cancel="$router.replace({ name: $route.name, query: { page: '組合列表' } })" :align="'flex-end'" :style="{paddingRight: '15px'}"/>
      </div>
    <DialogDef @close="selectone=false" :show="selectone" label="優惠券" :height="'630px'">
      <div :style="{padding: '33px 30px 52px', overflowY: 'auto', overflowX: 'hidden', maxHeight: '560px', gap: '20px', display: 'flex', flexDirection: 'column'}">
        <RT :options="ctypes" :defaultValue="couponType" @input="couponType=$event"/>
        <Coupon v-for="cp in couponsOrg" :key="cp._id"
        :image="cp.image"
        :couponName="cp.couponName"
        :productName="cp.productName"
        :productID="cp.productID"
        :startTime="cp.startTime"
        :expireTime="cp.expireTime"
        :duration="cp.duration"
        @selectThis="coupons.push({ item: cp, count: 1});selectone=false"
        />
      </div>
    </DialogDef>
    <DialogDef @close="selectGroup=false" :show="selectGroup" label="商品群組" :height="'630px'" v-if="selectGroup">
      <div :style="{padding: '33px 30px 52px', overflowY: 'auto', overflowX: 'hidden', maxHeight: '560px', gap: '20px', display: 'flex', flexDirection: 'column'}">
        <RT :options="groupsList.map(e => e.name)" :defaultValue="groupname" @input="groupname=$event"/>
        <div v-if="group">
          <div class="groupTitle">
            <div>{{group.name}}</div>
            <SaveBtn :text="'確定'" @click="groups.push(group);selectGroup=false"/>
          </div>
          <div class="groupItems">
            <div v-for="(gr, g) in group.items" :key="`gr-${g}`">
              <div>{{gr.item.name}}</div>
              <div v-if="g>0">${{gr.priceDiff}}</div>
              <div v-else>預設</div>
            </div>
          </div>
        </div>
      </div>
    </DialogDef>
  </La3>
</template>

<script>
import { mapState } from 'vuex'
import switchboxsVue from '../../../components/radio/switch.vue'
import Num from '../../../components/input/countEditable.vue'
import Btns from '../../../components/btn/btns.vue'
import DelBtn from '../../../components/btn/del.vue'
import SaveBtn from '../../../components/btn/save.vue'
import RBtn from '../../../components/btn/round.vue'
import Draggable from 'vuedraggable'
import Select from '../../../components/select.vue'
import La3 from '../../../components/layout/La3.vue'
import SearchInput from '../../../components/input/search.vue'
import { getapi, uploadimage, postapi } from '../../../store/fetch'
import CheckboxVue from '../../../components/checkbox/checkbox.vue'
import DialogDef from '../../../components/dialognoPadding2.vue'
import Coupon from '../../../components/couponBox.vue'
const { VUE_APP_BASE_URL } = process.env
export default {
  props: ['types', 'typesp'],
  components: {
    La3,
    Num,
    Select,
    SearchInput,
    Draggable,
    RBtn,
    DelBtn,
    SaveBtn,
    Btns,
    CheckboxVue,
    switchboxsVue,
    DialogDef,
    Coupon
  },
  data () {
    return {
      store: null,
      groupname: null,
      selectGroup: false,
      selectone: false,
      prods: [],
      type: null,
      usage: null,
      searchText: null,
      item: null,
      coupons: [],
      couponsOrg: [],
      single: [],
      multi: [[]],
      groups: [],
      groupsList: [],
      finalprice: 0,
      discount: 0,
      image: null,
      couponType: '抵用券',
      VUE_APP_BASE_URL
    }
  },
  async mounted () {
    const coupons = await getapi(`couponTemplate/select?couponType=${this.couponType}`)
    this.couponsOrg = coupons
    this.groupsList = await getapi('options/group')
    this.groupname = this.groupsList[0]?.name || null
    await this.getprods()
  },
  computed: {
    group () {
      return this.groupsList.find(e => e.name === this.groupname)
    },
    ...mapState({
      restaurants: 'restaurants',
      usages: 'usages',
      ctypes: 'couponTypes'
    }),
    id () {
      return this.$route.query.id
    },
    pricedefault () {
      const groupsprice = this.reduce([...this.groups].map(e => e.items[0].item.price))
      return groupsprice + [...this.single, ...this.multi].filter(e => e[0]).map(e => e[0]).map(e => e.item).map(e => e.price || 0).reduce((a, b) => a + b, 0)
    }
  },
  watch: {
    async couponType () {
      const coupons = await getapi(`couponTemplate/select?couponType=${this.couponType}`)
      this.couponsOrg = coupons
    },
    searchText () { this.getprods() },
    store () { this.getprods() },
    type () { this.getprods() },
    usage () { this.getprods() },
    discount () {
      this.finalprice = this.pricedefault - this.discount
    },
    finalprice () {
      this.discount = this.pricedefault - this.finalprice
      this.$refs.price.classList.remove('highlight')
    },
    'item.name' () {
      if (this.$refs.name) this.$refs.name.classList.remove('highlight')
    },
    'item.unit' () {
      if (this.$refs.name) this.$refs.name.classList.remove('highlight')
    },
    'item.area' () {
      if (this.$refs.name) this.$refs.name.classList.remove('highlight')
    },
    'item.type' () {
      if (this.$refs.name) this.$refs.name.classList.remove('highlight')
    },
    id: {
      async handler () {
        if (this.id) {
          const item = await getapi(`rest_product/set/edit/${this.id}`)
          this.item = item
          this.item.name2 = (item.name2 || '')
          this.item.group = (item.group || false)
          this.item.groupNum = (item.groupNum || 10)
          this.item.groupUnit = (item.groupUnit || '桌')
          this.item.isFloat = (item.isFloat || false)
          this.item.area = (item.area || [])
          this.coupons = (item.coupons || [])
          this.groups = (item.groups || [])
          this.single = [] // this.item.items.map(e => e.filter(a => a.item)).filter(e => e.length === 1)
          const multi = this.item.items // .map(e => e.filter(a => a.item)).filter(e => e.length > 1)
          console.log('multi', multi, this.single)
          this.multi = multi.length > 0 ? multi : [[]]
          this.image = this.item?.image ? { filename: this.item.image } : null
          this.finalprice = this.item.price
          this.discount = this.pricedefault - this.item.price
        } else {
          this.item = null
        }
      },
      immediate: true
    }
  },
  methods: {
    goup (index) {
      const a = JSON.parse(JSON.stringify(this.multi[index]))
      this.multi.splice(index, 1)
      this.multi.splice(index - 1, 0, a)
    },
    godown (index) {
      const a = JSON.parse(JSON.stringify(this.multi[index]))
      this.multi.splice(index, 1)
      this.multi.splice(index + 1, 0, a)
    },
    changeBG (bo, index) {
      const ref = this.$refs[`drop-${index}`][0] || this.$refs[`drop-${index}`]
      console.log('changeBG', bo, index, `drop-${index}`, ref)
      if (bo) {
        ref.classList.add('in')
      } else {
        ref.classList.remove('in')
      }
    },
    async saveSet () {
      const { name, name2, type, description, area, unit, id, group, groupNum, groupUnit, isFloat } = this.item
      if (!type) {
        this.$refs.type.classList.add('highlight')
        this.$refs.type.scrollIntoView()
        return false
      }
      if (!name) {
        this.$refs.name.classList.add('highlight')
        this.$refs.name.scrollIntoView()
        return false
      }
      if (!area || area.length === 0) {
        this.$refs.area.classList.add('highlight')
        this.$refs.area.scrollIntoView()
        return false
      }
      if (this.finalprice === null || isNaN(parseInt(this.finalprice))) {
        this.$refs.price.classList.add('highlight')
        return false
      }
      const items = [...this.single, ...this.multi].filter(e => e.length > 0)
      const r = await postapi(`rest_product/set/${this.item._id}`, {
        name, name2, id, type, description, area, unit, group, groupNum, groupUnit, isFloat, items, image: this.image?.filename, price: this.finalprice, coupons: this.coupons, groups: this.groups
      })
      if (r) {
        this.$router.replace({ name: this.$route.name, query: { page: '組合列表' } })
      }
    },
    startDrag (event, item) {
      console.log('startDrag', item)
      event.dataTransfer.dropEffect = 'move'
      event.dataTransfer.effectAllowed = 'move'
      event.dataTransfer.setData('itemID', item)
    },
    onDrop (event, mode, listIndex) {
      const itemID = event.dataTransfer.getData('itemID')
      const item = this.prods.find(it => it._id === itemID)
      if (mode === 'single') {
        this.single.push([{ item, priceDiff: 0, selectable: true }])
      } else if (mode === 'multi') {
        this.multi[listIndex].push({ item, priceDiff: 0, selectable: true })
      }
    },
    async uploadFile (event, folder) {
      const ret = await uploadimage(event, folder)
      const image = ret
      image.filename = `/${folder}/${image.filename}`
      this.image = image
    },
    async getprods () {
      const params = {}
      if (this.type) params.category = this.type
      if (this.store) params.area = this.store
      if (this.usage) params.type = this.usage
      if (this.searchText) params.searchText = this.searchText
      this.prods = await getapi('rest_product/single?' + new URLSearchParams(params))
    }
  }
}
</script>
<style lang="scss">
button.clone>div {
  background-color: #CACACA!important;
}
#settingsets {
  .checkboxqwe {
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    letter-spacing: 0.05em;
    color: var(--color-pri);
  }
}
</style>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.groupTitle {
  font-size: 24px;
  color: var(--color-pri);
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.groupItems {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  &>div{
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 20px;
  }
}
.imageBox {
  max-width: 461px;
  max-height: 346px;
}

.setTitle {
  text-align: start;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 32px;
  line-height: 38px;
  letter-spacing: 0.1em;
  color: var(--color-pri);
}
label#uploadimage {
  width: 461px;
  height: 346px;
  margin-left: 15px;
}
.uploadimage {
  margin-right: auto;
  width: 461px;
  height: 346px;
  background-image: url(/upload.svg);
  background-size: contain;
  display: inline-flex;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-position: left;
  position: relative;
  &::before {
    position: absolute;
    content: '匯入圖片';
    display: inline-flex;
    width: 100px;
    height: 35px;
    background-color: var(--color-pri);
    align-items: center;
    justify-content: center;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    border-radius: 20px;
    left: 230px;
    top: 204px;
    transform: translateX(-50%);
  }
}
.setfields {
  overflow-y: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-block: 20px;
  &>div {
    width: -webkit-fill-available;
    height: fit-content;
  }
  input, select {
    height: 40px;
    box-sizing: border-box;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: var(--color-pri);
    padding-left: 14px;
    border: 1px solid #C4C4C4;
    border-radius: 3px;
    box-sizing: border-box;
    &.center {
      text-align: center;
      padding-left: 0;
    }
  }
  input {
    width: calc(100% - 28px);
    border: none;
    color: var(--color-letter);
    border-bottom: 1px solid var(--color-border);
  }
  #group {
    width: 1.5em;
    height: 1.5em;
    border: 1px solid var(--color-border);
    accent-color: var(--color-pri);
  }
  input[type=text] {
    border: 1px solid var(--color-border);
  }
  textarea {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
    margin-top: 14px;
    width: calc(100% - 28px);
    height: 150px;
    border: 1px solid var(--color-border);
    padding: .75em;
    border-radius: 5px;
  }
  .df {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 30px;
  }
  .field {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &.c {
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      &>:nth-child(1) {
        margin-left: 14px;
      }
    }
    &.top {
      align-items: center;
      &::before {
        display: flex;
        align-items: center;
      }
    }
    &::before {
      margin-right: 15px;
      content: attr(label);
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 150%;
      letter-spacing: 0.1em;
      color: var(--color-pri);
      white-space: nowrap;
    }
    &.highlight::before {
      color: red;
    }
  }
}
.drop {
  min-height: 60px;
  width: 100%;
  &.in {
    background-color: var(--color-bar);
  }
}
.default {
  font-weight: 400;
  font-size: 16px;
  line-height: 180%;
  color: #FFFFFF;
  width: 70px;
  height: 30px;
  background: #9DC56E;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.items-body {
  padding-block: 14px 0;
  gap: 9px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-inline: 20px;
}
.len1, .len2 {
  border: 2px solid var(--color-pri);
  width: 100%;
  border-radius: 10px;
  &>div:nth-child(1) {
    height: 55px;
     width: 100%;
     border-bottom: 1px solid var(--color-pri);
     display: flex;
     align-items: flex-end;
     justify-content: flex-start;
     padding-block: 16px 11px;
     gap: 15px;
     &>div:nth-child(1) {
      font-weight: 500;
      font-size: 24px;
      line-height: 28px;
      letter-spacing: 0.1em;
      color: var(--color-pri);
     }
     &>div:nth-child(2) {
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
      letter-spacing: 0.1em;
      color: #959595;
      vertical-align: text-bottom;
     }
  }
  button {
    background-color: transparent;
    width: 40px;
    color: var(--color-checked);
    &:disabled {
      color: #C4C4C4;
    }
  }
}
.len2.coupon>:nth-child(1) {
  align-items: center;
}
.len2.groups>:nth-child(1) {
  align-items: center;
}
.len1>:nth-child(1) {
  padding-inline: 28px;
}
.len2>:nth-child(1) {
  padding-inline: 19px;
}
.single, .mulit {
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  letter-spacing: 0.1em;
  color: #787878;
  &>div:nth-child(1) {
    display: inline;
    width: fit-content;
    margin-right: 20px;
    white-space: nowrap;
    text-align: start;
  }
  .priceDiff {
    font-weight: 400;
    font-size: 18px;
    line-height: 150%;
    letter-spacing: 0.05em;
    color: var(--color-pri);
    display: flex;
    flex-wrap: nowrap;
    white-space: nowrap;
    align-items: center;
    gap: 8px;
    input {

      font-weight: 500;
      font-size: 18px;
      line-height: 180%;
      letter-spacing: 0.1em;
      color: #FF7373;
      text-align: center;
      width: 80px;
      height: 40px;
      border: 1px solid #C4C4C4;
      border-radius: 3px;
    }
  }
}
#priceCalculate {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 55px;
  background-color: var(--color-pri);
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  &>div{
    flex:1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-inline: 24px;

    &::before {
      content: attr(label);
      font-weight: 400;
      font-size: 20px;
      line-height: 150%;
      letter-spacing: 0.05em;
      color: #FFFFFF;
    }
    &>div {
      width: 169px;
      height: 42px;
      background: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-weight: 500;
      font-size: 24px;
      line-height: 150%;
      letter-spacing: 0.15em;
      color: #787878;
      padding-inline: 16px 9px;
      &::before {
        content: '$';
      }
      input {
        width: 100%;
        height: 42px;
        border: none;
        font-weight: 500;
        font-size: 24px;
        line-height: 150%;
        letter-spacing: 0.15em;
        color: #787878;
      }
    }
    &.highlight::before {
      color: red;
    }
  }
  &>div:not(:last-child) {
    border-right: 1px solid #FFFFFF;
  }
}
.prod {
  width: 100%;
  background-color: var(--color-infobox);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-inline: 19px 24px;
  height: 60px;
  min-height: 60px;
  font-weight: 400;
  font-size: 20px;
  line-height: 23px;
  letter-spacing: 0.1em;
  &>div:nth-child(2) {
    margin-left: auto;
  }
  &::after {
    content: '';
    width: 40px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    mask-image: url(/ham.svg);
    background-color: var(--color-checked);
    mask-repeat: no-repeat;
    mask-position: center right;
  }
}
</style>
